module.exports = __webpack_public_path__ + "img/operation-evac.09afdc6a.jpeg";